import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Contactpage = () => {
  return (
    <>
      <Header />
      <div id="myDIV" style={{ backgroundImage: `url(${require('../assets/images/meetings-bg.jpg')})` }}>
          <div>
            <div class="row">
              <div class="col-lg-12">
                <div class="caption caption-content">
                  <h2 style={{padding:"20px",color:"white"}}>TBD</h2>
                  <ul class="sub-content">
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
      </div>
      <Footer />
    </>
  );
};

export default Contactpage;
